import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeSafeHTML',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {

	constructor(
		private sanitized: DomSanitizer,
	) { }

	public transform(value: string): SafeHtml {
		return this.sanitized.bypassSecurityTrustHtml(value);
	}
}
